import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  MultiSelect,
  rem,
  Select,
  SelectProps,
  TextInput,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import {
  IconBarcode,
  IconCalendar,
  IconCoin,
  IconDiscount,
  IconFileExport,
  IconMoneybag,
  IconSearch,
  IconStatusChange,
} from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  repositoryDelivery,
  repositoryPos,
  typeGv,
} from "../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { _localization } from "../../../config/location";
import {
  DeliveryMoneyReportItem,
  DeliveryTransaction,
} from "../../../model/DeliveryMoneyReport";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItemModel } from "../../../model/SelectListItem";
import { DefaultMemoizedCellDate } from "../../../_base/_const/baseHook";
import { getDeliveryStatusSelectMdm } from "../../../service/getSelectApi";
import { ComboboxItem } from "../../../model/ComboboxItem";
import { IconCheck } from "@tabler/icons-react";
import { DatePickerInput } from "@mantine/dates";
import dayjs from "dayjs";
import * as xlsx from "xlsx";
import { toast } from "react-toastify";
import { getValueById } from "../../../_base/helper/FunctionHelper";

// BÁO CÁO TIỀN ĐƠN HÀNG
const DeliveryMoney = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<DeliveryTransaction[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [dataTblDeliveryStatusSelect, setDataTblDeliveryStatusSelect] =
    useState<ComboboxItem[]>([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  //Mã nhân viên
  const [dataEmployee, setDataEmployee] = useState<SelectListItemModel[]>([]);

  //dataExportExcel
  const [dataExportExcel, setDataExportExcel] = useState<any[]>([]);

  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 2, xl: 2 };

  type SearchFormValues = {
    KeySearch: string;
    StatusId: string;
    IdNVGh: string;
    HasAttribute1: string;
    StartDate: string;
    EndDate: string;
    departmentName: string;
    ListStatusId: string[];
  };

  const innitStateSearch: SearchFormValues = {
    KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
    StatusId: _searchJson && checkedPinSearch ? _searchJson?.StatusId : "",
    IdNVGh: _searchJson && checkedPinSearch ? _searchJson?.IdNVGh : "",
    HasAttribute1:
      _searchJson && checkedPinSearch ? _searchJson?.HasAttribute1 : "",
    StartDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.StartDate
        : dayjs().subtract(5, "day").format("YYYY-MM-DDT00:00:00"),
    EndDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.EndDate
        : dayjs().format("YYYY-MM-DDT23:59:59"),
    departmentName:
      _searchJson && checkedPinSearch ? _searchJson?.departmentName : "",
    ListStatusId:
      _searchJson && checkedPinSearch ? _searchJson?.ListStatusId : [],
  };

  const bankOptions = [
    { label: "Vietcombank", value: "1" },
    { label: "VietinBank", value: "2" },
    {
      label: "Agribank",
      value: "3",
    },
    { label: "BIDV", value: "4" },
    { label: "Techcombank", value: "5" },
    { label: "ACB", value: "6" },
    { label: "Sacombank", value: "7" },
    { label: "SHB", value: "8" },
    { label: "MB Bank", value: "9" },
    { label: "Eximbank", value: "10" },
    { label: "VPBank", value: "11" },
    { label: "HDBank", value: "12" },
    { label: "TPBank", value: "13" },
    { label: "LienVietPostBank", value: "14" },
    { label: "SeABank", value: "15" },
    { label: "VIB", value: "16" },
    { label: "MSB", value: "17" },
    { label: "SCB", value: "18" },
    { label: "OCB", value: "19" },
    { label: "DongA Bank", value: "20" },
  ];

  const formSeachInput = useForm<SearchFormValues>({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });

  //Lấy list nhân viên
  const fetchSelectEmployee = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmEmployee/get-select"
    );
    if (dataApi && dataApi.success) {
      console.log("dataApi", dataApi);
      const filteredData = dataApi.data
        .filter(
          (item: any) =>
            item.att1 !== null && item.value !== null && item.text !== null
        )
        .map((i: any) => ({
          value: i.value,
          label: ` ${i.att1} - ${i.text}`,
        }));
      setDataEmployee(filteredData);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    try {
      // Tạo URLSearchParams để quản lý các tham số
      const params = new URLSearchParams();

      // Thêm thông tin phân trang
      params.append(
        "Skip",
        (pagination.pageIndex * pagination.pageSize).toString()
      );
      params.append("Take", pagination.pageSize.toString());

      // Lấy giá trị từ form và thêm vào params nếu có giá trị
      const {
        KeySearch,
        StatusId,
        IdNVGh,
        HasAttribute1,
        EndDate,
        StartDate,
        departmentName,
        ListStatusId,
      } = formSeachInput.getValues();
      if (KeySearch) params.append("KeySearch", KeySearch);
      if (StatusId) params.append("StatusId", StatusId);
      if (IdNVGh) params.append("IdNVGh", IdNVGh);
      if (HasAttribute1) params.append("HasAttribute1", HasAttribute1);
      if (StartDate) params.append("StartDate", StartDate);
      if (EndDate) params.append("EndDate", EndDate);
      if (departmentName) params.append("DeliveryDepartmentId", departmentName);
      // Chuyển đổi mảng `StatusId` thành chuỗi nếu có giá trị
      if (ListStatusId && ListStatusId.length > 0) {
        ListStatusId.forEach((id) => params.append("ListStatusId", id));
      }

      const url = `/api/v1/TblDelivery/get-list-amount-report?${params.toString()}`;

      const response = await repositoryDelivery.get<MessageResponse<any>>(
        `${url}`
      );
      if (response && response.success) {
        const result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        // Gọi API lần thứ hai nếu cần lấy toàn bộ dữ liệu
        if (response.totalCount > pagination.pageSize) {
          const allParams = new URLSearchParams(params);
          allParams.set("Skip", "0"); // Đặt Skip = 0
          allParams.set("Take", response.totalCount.toString()); // Cập nhật Take = totalCount
          const allUrl = `/api/v1/TblDelivery/get-list-amount-report?${allParams.toString()}`;
          const allResponse = await repositoryDelivery.get<
            MessageResponse<any>
          >(`${allUrl}`);
          if (allResponse && allResponse.success) {
            setDataExportExcel(allResponse.data); // Ghi đè dữ liệu với toàn bộ kết quả
          }
        } else {
          setDataExportExcel(result); // Ghi đè dữ liệu với toàn bộ kết quả
        }
      } else {
        setData([]);
        setRowCount(0);
        setIsLoading(false);
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify(formSeachInput.getValues())
      );
    }
  };
  const columns = React.useMemo<MRT_ColumnDef<DeliveryTransaction>[]>(
    () => [
      {
        accessorKey: "transactionNumber",
        header: "Số giao dịch",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "sourceCode",
        header: "Số chứng từ gốc",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      // {
      //   accessorKey: "statusId",
      //   header: "ID trạng thái",
      //   Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      // },

      // {
      //   header: "Thông tin trên App",
      //   Header: () => (
      //     <Badge
      //       size="md"
      //       variant="gradient"
      //       gradient={{ from: "blue", to: "cyan", deg: 90 }}
      //     >
      //       Thông tin trên App
      //     </Badge>
      //   ),
      //   columns: [
      {
        accessorKey: "statusName",
        header: "Trạng thái đơn giao hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 250,
      },
      {
        accessorKey: "paymentStatus",
        header: "Trạng thái thanh toán",
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue === "DA_THANH_TOAN"
              ? "Đã thanh toán"
              : renderedCellValue === ""
              ? "KHONG_CAN_THANH_TOAN"
              : ""}
          </>
        ),
        size: 250,
      },
      {
        accessorKey: "orderAmountTotal",
        header: "Tổng tiền đơn hàng",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue) || 0}</>
        ),
      },
      {
        accessorKey: "debtName",
        header: "Phương thức thanh toán",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 250,
      },
      {
        header: "Chứng từ thu trước",
        accessorKey: "chungTuThuTruoc",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 250,
      },
      {
        accessorKey: "attribute2",
        header: "Tiền thu trước",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue) || 0}</>
        ),
        size: 250,
      },
      {
        accessorKey: "amountDue",
        header: "Số tiền giao vận phải thu",
        size: 250,
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue) || 0}</>
        ),
      },
      //   ],
      // },

      // {
      //   header: "Thông tin trên App",
      //   Header: () => (
      //     <Badge
      //       size="md"
      //       variant="gradient"
      //       gradient={{ from: "blue", to: "cyan", deg: 90 }}
      //     >
      //       Thông tin trên App
      //     </Badge>
      //   ),
      //   columns: [
      {
        accessorKey: "paymentCash",
        header: "Tiền mặt",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue) || 0}</>
        ),
      },
      {
        accessorKey: "paymentBankTransfer",
        header: "Tiền chuyển khoản",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue) || 0}</>
        ),
      },
      {
        accessorKey: "cardPaymentAmount",
        header: "Cà thẻ",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue) || 0}</>
        ),
      },

      {
        header: "Ngân hàng", //chưa có dữ liệu
        accessorKey: "nganHang",
        Cell: ({ renderedCellValue }) => (
          <>
            {getValueById(
              renderedCellValue?.toString() ?? "",
              bankOptions,
              "label"
            )}
          </>
        ),
      },
      //   ],
      // },

      // {
      //   header: "Thông tin hạch toán POS",
      //   Header: () => (
      //     <Badge
      //       size="md"
      //       variant="gradient"
      //       gradient={{ from: "blue", to: "cyan", deg: 90 }}
      //     >
      //       Thông tin hạch toán POS
      //     </Badge>
      //   ),
      //   columns: [
      {
        header: "Tiền mặt (Kế toán hạch toán POS)",
        accessorKey: "tongThu",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue) || 0}</>
        ),
      },
      {
        accessorKey: "attribute4",
        header: "Thông tin phiếu thu",
        size: 300,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },

      {
        header: "Tiền chuyển khoản(Kế toán hạch toán POS)",
        accessorKey: "tongCk",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue) || 0}</>
        ),
      },

      {
        accessorKey: "attribute3",
        header: "Thông tin phiếu báo có",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 250,
      },

      {
        accessorKey: "returnAmount",
        header: "Tiền hàng trả lại",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue) || 0}</>
        ),
        size: 250,
      },
      {
        accessorKey: "returnOrderNumber",
        header: "Số chứng từ nhập lại",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 250,
      },
      //   ],
      // },

      // {
      //   header: "Công nợ giao vận",
      //   Header: () => (
      //     <Badge
      //       size="md"
      //       variant="gradient"
      //       gradient={{ from: "blue", to: "cyan", deg: 90 }}
      //     >
      //       Công nợ giao vận
      //     </Badge>
      //   ),
      //   columns: [
      {
        header: "Số tiền GV chưa nộp",
        accessorKey: "tienGVChuaNop",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue) || 0}</>
        ),
      },
      {
        header: "TM",
        accessorKey: "tm",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue) || 0}</>
        ),
      },
      {
        header: "CK",
        accessorKey: "ck",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue) || 0}</>
        ),
      },
      //   ],
      // },

      {
        accessorKey: "departmentName",
        header: "Phòng ban GV",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },

      {
        accessorKey: "shippingName",
        header: "Mã nhân viên",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "shippingCode",
        header: "Tên NV giao hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "finishDate",
        header: "Ngày hoàn thành",
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "note",
        header: "Ghi chú của NVGH",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },

      // {
      //   accessorKey: "paymentAmount",
      //   header: "Số tiền giao vận đã thu",
      //   size: 250,
      //   Cell: ({ renderedCellValue }) => (
      //     <>{formatCurrencyVND(renderedCellValue)}</>
      //   ),
      // },
      // {
      //   accessorKey: "amountRemaining",
      //   header: "Số tiền giao vận còn lại",
      //   size: 250,
      //   Cell: ({ renderedCellValue }) => (
      //     <>{formatCurrencyVND(renderedCellValue)}</>
      //   ),
      // },

      // {
      //   accessorKey: "orderAmountPaid",
      //   header: "Số tiền kế toán đã thu",
      //   Cell: ({ renderedCellValue }) => (
      //     <>{formatCurrencyVND(renderedCellValue)}</>
      //   ),
      //   size: 200,
      // },
      // {
      //   accessorKey: "orderAmountRemaining",
      //   header: "Số tiền kế toán chưa thu",
      //   Cell: ({ renderedCellValue }) => (
      //     <>{formatCurrencyVND(renderedCellValue)}</>
      //   ),
      //   size: 250,
      // },
      // {
      //   accessorKey: "iwReturnAmount",
      //   header: "Tiền hàng trả (chưa nhập kho)",
      //   Cell: ({ renderedCellValue }) => (
      //     <>{formatCurrencyVND(renderedCellValue)}</>
      //   ),
      //   size: 250,
      // },
      // {
      //   accessorKey: "attribute1",
      //   header: "Tiền mặt chưa nộp kế toán",
      //   Cell: ({ renderedCellValue }) => (
      //     <>{formatCurrencyVND(renderedCellValue)}</>
      //   ),
      //   size: 250,
      // },

      // {
      //   accessorKey: "shippingId",
      //   header: "ID giao hàng",
      //   Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      // },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["transactionNumber", "sourceCode"],
        // right: ["tTienDh", "action"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  const dataDeliveryStatusSelect = async () => {
    try {
      const getData = await getDeliveryStatusSelectMdm();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblDeliveryStatusSelect(mappedData);
    } catch (error) {
      console.error("Error in dataDeliveryStatusSelect: ", error);
    }
  };

  const optionColorsAccount: Record<
    | "Đã phân công"
    | "Lập đơn giao hàng"
    | "Đang giao hàng"
    | "Đã đến nơi"
    | "Đơn hàng giao chưa thành công do Khách hàng"
    | "Đơn hàng giao chưa thành công do Hacom"
    | "Hàng đã giao"
    | "Hàng đã giao - nối chuyến"
    | "Hủy phân công"
    | "Nối chuyến"
    | "Hủy đơn",
    string
  > = {
    "Đã phân công": "lime",
    "Lập đơn giao hàng": "green",
    "Đang giao hàng": "teal",
    "Đã đến nơi": "cyan",
    "Đơn hàng giao chưa thành công do Khách hàng": "blue",
    "Đơn hàng giao chưa thành công do Hacom": "indigo",
    "Hàng đã giao": "violet",
    "Hàng đã giao - nối chuyến": "grape",
    "Hủy phân công": "red",
    "Hủy đơn": "#c91a25",
    "Nối chuyến": "yellow",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsAccount[
            option.label as
              | "Đã phân công"
              | "Lập đơn giao hàng"
              | "Đang giao hàng"
              | "Đã đến nơi"
              | "Đơn hàng giao chưa thành công do Khách hàng"
              | "Đơn hàng giao chưa thành công do Hacom"
              | "Hàng đã giao"
              | "Hàng đã giao - nối chuyến"
              | "Hủy phân công"
              | "Hủy đơn"
              | "Nối chuyến"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  // const handleExport = () => {
  //   try {
  //     const worksheet = xlsx.utils.json_to_sheet(dataExportExcel);
  //     const workbook = xlsx.utils.book_new();
  //     xlsx.utils.book_append_sheet(workbook, worksheet, "Data");
  //     xlsx.writeFile(workbook, "Bao_cao_tien_don_hang.xlsx");
  //     toast.success("Export excel thành công", { autoClose: 1500 });
  //   } catch (error) {
  //     toast.error("Export excel thất bại", { autoClose: 1500 });
  //   }
  // };

  const handleExport = () => {
    try {
      // Tạo ánh xạ tiêu đề từ columns
      const columnHeaders = columns.reduce((acc, column) => {
        if (column.accessorKey && column.header) {
          acc[column.accessorKey] = column.header; // Tạo ánh xạ giữa accessorKey và header
        }
        return acc;
      }, {} as Record<string, string>);

      // Lấy thứ tự cột từ columns
      const columnOrder = columns
        .filter((column) => column.accessorKey) // Chỉ lấy các cột có accessorKey
        .map((column) => column.accessorKey as string);

      // Chuyển đổi dữ liệu với tiêu đề cột mới và sắp xếp theo thứ tự cột
      const transformDataForExport = (data: any[]) => {
        return data.map((row) => {
          const transformedRow: any = {};
          columnOrder.forEach((key) => {
            if (columnHeaders[key]) {
              // Kiểm tra nếu cột là ngày thì định dạng lại
              if (key === "createDate" || key === "finishDate") {
                transformedRow[columnHeaders[key]] = row[key]
                  ? dayjs(row[key]).format("DD-MM-YYYY") // Định dạng ngày
                  : ""; // Nếu không có giá trị, để trống
              } else {
                transformedRow[columnHeaders[key]] = row[key]; // Các cột khác giữ nguyên
              }
            }
          });
          return transformedRow;
        });
      };

      const transformedData = transformDataForExport(dataExportExcel);

      // Tạo worksheet và workbook
      const worksheet = xlsx.utils.json_to_sheet(transformedData);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Data");

      // Ghi file Excel
      xlsx.writeFile(workbook, "Bao_cao_tien_don_hang.xlsx");
      toast.success("Export excel thành công", { autoClose: 1500 });
    } catch (error) {
      console.error("Error exporting Excel:", error);
      toast.error("Export excel thất bại", { autoClose: 1500 });
    }
  };

  useEffect(() => {
    const run = async () => {
      await fetchSelectEmployee();
      await dataDeliveryStatusSelect();
    };
    run();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <Box pos="relative">
      <LoadingOverlayCustom visible={visible} />
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
        <Button
          leftSection={
            <IconFileExport style={{ width: rem(14), height: rem(14) }} />
          }
          onClick={() => handleExport()}
        >
          Export Excel
        </Button>
      </Flex>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <TextInput
              placeholder="Nhập từ khóa"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconCalendar color="#15aabf" />}
              key={formSeachInput.key("StartDate")}
              {...formSeachInput.getInputProps("StartDate")}
              value={
                formSeachInput.getValues().StartDate
                  ? dayjs(formSeachInput.getValues().StartDate).toDate()
                  : null // Nếu không có giá trị, đặt null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "StartDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                )
              }
              maxDate={new Date()}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
              key={formSeachInput.key("EndDate")}
              {...formSeachInput.getInputProps("EndDate")}
              value={
                formSeachInput.getValues().EndDate
                  ? dayjs(formSeachInput.getValues().EndDate).toDate()
                  : null // Nếu không có giá trị, đặt null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "EndDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                )
              }
              maxDate={new Date()}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Trạng thái"
              clearable
              data={dataTblDeliveryStatusSelect}
              leftSection={<IconStatusChange color="#15aabf" />}
              value={
                formSeachInput.getValues()?.ListStatusId &&
                formSeachInput.getValues()?.ListStatusId?.length > 0
                  ? formSeachInput.getValues()?.ListStatusId
                  : []
              }
              // onClick={() => {
              //   if (dataTblDeliveryStatusSelect.length === 0) {
              //     dataDeliveryStatusSelect();
              //   }
              // }}
              // renderOption={renderSelectOptionStatus}
              // comboboxProps={{ width: 400 }}
              onChange={(values) => {
                formSeachInput.setFieldValue("ListStatusId", values);
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Mã nhân viên"
              clearable
              searchable
              data={dataEmployee}
              value={
                dataEmployee.length > 0 ? formSeachInput.getValues().IdNVGh : ""
              }
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              onChange={(e, value) => {
                formSeachInput.setFieldValue("IdNVGh", e ? e.toString() : "");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Tiền mặt chưa nộp kế toán"
              clearable
              leftSection={<IconCoin size={20} color="#15aabf" />}
              data={[
                { value: "true", label: "Đơn có tiền mặt chưa nộp kế toán" },
                {
                  value: "false",
                  label: "Đơn không có tiền mặt chưa nộp kế toán",
                },
              ]}
              value={formSeachInput.getValues().HasAttribute1 || ""}
              onChange={(e, value) => {
                formSeachInput.setFieldValue(
                  "HasAttribute1",
                  e ? e.toString() : ""
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              placeholder="Bộ phận"
              // defaultValue={keySearch}
              leftSection={<IconSearch color="#15aabf" />}
              data={typeGv}
              key={formSeachInput.key("departmentName")}
              {...formSeachInput.getInputProps("departmentName")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </Box>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default DeliveryMoney;
